<template>
  <div>
    <div />
  </div>
</template>

<script>
export default {
  name: 'VbSales',
  components: {},
}
</script>
